import React, { useEffect } from 'react'
import ReactGA from 'react-ga';



const Hero = () => {

  useEffect(()=>{
    ReactGA.pageview(window.location.pathname)
  },[])

  return (
    <>
           <section className="text-gray-600 body-font">
  <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col-reverse items-center">
    <div data-aos="zoom-out-right" className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
      <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">Before they sold out
        <br className="hidden lg:inline-block" />readymade gluten
      </h1>
      <p className="mb-8 leading-relaxed">Copper mug try-hard pitchfork pour-over freegan heirloom neutra air plant cold-pressed tacos poke beard tote bag. Heirloom echo park mlkshk tote bag selvage hot chicken authentic tumeric truffaut hexagon try-hard chambray.</p>
      <div className="flex justify-center">
        <button className="inline-flex text-white bg-black border-0 py-2 px-6 focus:outline-none hover:bg-black rounded text-lg">Button</button>
        <button className="ml-4 inline-flex text-gray-700 bg-gray-100 border-0 py-2 px-6 focus:outline-none hover:bg-gray-200 rounded text-lg">Button</button>
      </div>
    </div>
    <div data-aos="zoom-out-left" className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
      <img onClick={()=>{
        ReactGA.event({
          category:"blogs",
          action:'test action',
          label : "click on image",
          value :"simple image"
        })
      }} className="object-cover object-center rounded" alt="hero" src="https://plus.unsplash.com/premium_photo-1666107278222-862cd7890c5e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1177&q=80" />
    </div>
  </div>
</section>

    </>
  )
}

export default Hero